import { Tooltip } from '@sparemin/blockhead';
import React from 'react';
import * as S from './styles';

export interface OptionProps {
  label: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  tooltipContents?: React.ReactNode;
  subOptions?: React.ReactNode;
  onChange?: (isSelected: boolean) => void;
}

const Option: React.FC<OptionProps> = ({
  label,
  isSelected,
  isDisabled,
  tooltipContents,
  subOptions,
  onChange,
}) => {
  return (
    <Tooltip arrow contents={tooltipContents} isDisabled={!tooltipContents}>
      <div>
        <S.Option {...{ isSelected, isDisabled, onChange }}>
          <S.OptionText>{label}</S.OptionText>
        </S.Option>

        {isSelected && subOptions && (
          <S.SubOptions onPointerDown={(e) => e.stopPropagation()}>
            {subOptions}
          </S.SubOptions>
        )}
      </div>
    </Tooltip>
  );
};

export default Option;
